import { ClientFactories, ContextStore, Store } from 'bernie-plugin-mobx';

import { AdvertisingStore } from 'bernie-plugin-ads-loader-script';
import { ClientLogger } from 'bernie-client';
import { ContextInput } from 'bernie-context';
import { NOOP_LOGGER } from 'bernie-logger';

import { BexApiSource } from 'sources/bex-api-source';
import { getBexApiSdk } from 'sources/get-bex-api-sdk';

import { CurrentHotelStore } from './current-hotel-store';
import { DataDogStore } from './datadog-store';
import { MultiItemStore } from './multi-item-store';
import { PageLayoutStore } from './page-layout-store';
import { QualtricsStore } from './qualtrics-store';
import { SearchResultsStore } from './search-results-store';
import { UIPageStore } from './ui-page-store';

import { SearchCriteriaModel } from './models';

export const buildClientSideBexApiSource = (contextInput: ContextInput): BexApiSource => {
  const headers = { 'Device-User-Agent-ID': contextInput.identity.duaid };
  const api = getBexApiSdk(headers);

  return new BexApiSource(api, ClientLogger.getLoggerWithIdentifier('pwa.source.bexapi'));
};

export const stores: ClientFactories = {
  advertising: (): Store => new AdvertisingStore({}, ClientLogger.getLoggerWithIdentifier('pwa.store.advertising')),

  context: (): Store => new ContextStore(null, NOOP_LOGGER),

  currentHotel: ({ bexApiContext, l10n }): Store =>
    new CurrentHotelStore(
      buildClientSideBexApiSource(bexApiContext),
      {},
      l10n,
      ClientLogger.getLoggerWithIdentifier('pwa.store.currenthotel')
    ),
  searchCriteria: ({ l10n }): Store => new SearchCriteriaModel({}, l10n),

  searchResults: ({ bexApiContext, l10n }): Store =>
    new SearchResultsStore(
      buildClientSideBexApiSource(bexApiContext),
      {},
      ClientLogger.getLoggerWithIdentifier('pwa.store.searchresults'),
      l10n
    ),

  multiItem: ({ bexApiContext, l10n }): Store =>
    new MultiItemStore(buildClientSideBexApiSource(bexApiContext), {}, ClientLogger.getLoggerWithIdentifier('pwa.store.multiitem'), l10n),
  pageLayout: ({ bexApiContext }): Store =>
    new PageLayoutStore(buildClientSideBexApiSource(bexApiContext), {}, ClientLogger.getLoggerWithIdentifier('pwa.store.pagelayout')),
  qualtrics: (): Store => new QualtricsStore({}),
  datadog: (): Store => new DataDogStore({}),
  uiPage: (): Store => new UIPageStore({}),
};
